import { ChevronRight } from '@mui/icons-material';
import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';

function MetaCell({ label, value }) {
    return (
        <Stack spacing={0.25} sx={{ flex: 1 }}>
            <Typography variant="normal" sx={{ fontSize: '11px', color: 'subtext.main', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {label}
            </Typography>
            <Typography variant="heavy" sx={{ fontSize: '14px' }}>
                {value || '—'}
            </Typography>
        </Stack>
    );
}

function ContractEntry({ contract, onClick }) {
    return (
        <Paper
            elevation={1}
            onClick={onClick}
            sx={{
                px: 3,
                py: 2,
                cursor: onClick ? 'pointer' : 'default',
                '&:hover': onClick ? { boxShadow: 4 } : {},
                borderRadius: '12px',
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack spacing={1.5} sx={{ flex: 1 }}>
                    <Typography variant="heavy" sx={{ fontSize: '16px' }}>
                        {contract.name}
                    </Typography>
                    <Stack direction="row">
                        <MetaCell label="Contract ID" value={contract.external_id} />
                        <MetaCell label="Start Date" value={contract.start_date} />
                        <MetaCell label="End Date" value={contract.end_date} />
                    </Stack>
                </Stack>
                <ChevronRight sx={{ color: 'subtext.main', ml: 2 }} />
            </Stack>
        </Paper>
    );
}

export default ContractEntry;